import * as types from "./actionTypes";

export const postSwissportForm = (formName, formContent) => ({
  type: types.POST_SWISSPORT_FORM,
  payload: { formName, formContent },
});

export const setSwissportLoading = (isLoading) => {
  return {
    type: types.SWISSPORT_IS_LOADING,
    payload: isLoading,
  };
};
